if (!window.xwQuickAdd) {
window.xwQuickAdd = true;
document.addEventListener('click', function (e) {
var b = e.target.closest('.xw-quick-add');
if (!b) return;
e.preventDefault();
if (b.classList.contains('loading')) return;
b.classList.add('loading');
var fd = new FormData();
fd.append('id', b.dataset.variantId);
fd.append('quantity', 1);
fd.append('sections', 'main-cart,cart-drawer,cart-bubble');
fd.append('sections_url', window.location.pathname);
fetch(theme.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
.then(function (r) { return r.json(); })
.then(function (res) {
if (res.status) { window.alert(res.description || res.message); return; }
var map = [['Cart', 'main-cart', '.thb-cart-form'], ['Cart-Drawer', 'cart-drawer', '.cart-drawer'], ['cart-drawer-toggle', 'cart-bubble', '.thb-item-count']];
map.forEach(function (m) {
var el = document.getElementById(m[0]);
if (!el || !res.sections || !res.sections[m[1]]) return;
var target = el.querySelector(m[2]) || el;
var src = new DOMParser().parseFromString(res.sections[m[1]], 'text/html').querySelector(m[2]);
if (src) target.innerHTML = src.innerHTML;
});
var cd = document.getElementById('Cart-Drawer');
var hasDispatch = typeof dispatchCustomEvent === 'function';
if (cd && typeof OverlayManager !== 'undefined') { OverlayManager.open(cd); if (hasDispatch) dispatchCustomEvent('cart-drawer:open'); } else if (!cd) { window.location.href = theme.routes.cart_url; }
if (hasDispatch) dispatchCustomEvent('cart:item-added', { product: res });
})
.catch(function (err) { console.error(err); })
.finally(function () { b.classList.remove('loading'); });
});
}
